module.exports = __webpack_public_path__ + "media/ס.fffbb791.mp3";